module.exports = __webpack_public_path__ + "img/Frame 212_copy2.d531727f.png";